import React, { useEffect, useState } from 'react';
import { Box, Slide, Typography } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';

// Shows a slim bar under the app header only while the device is offline,
// so it never covers page content in the normal (online) state.
const OnlineStatus = () => {
  const [online, setOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setOnline(true);
    const handleOffline = () => setOnline(false);
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <Slide direction="down" in={!online} mountOnEnter unmountOnExit>
      <Box
        role="status"
        sx={{
          position: 'fixed',
          top: { xs: 56, sm: 64 },
          left: 0,
          right: 0,
          zIndex: 2000,
          bgcolor: 'error.main',
          color: 'error.contrastText',
          py: 0.5,
          px: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          boxShadow: 2,
        }}
      >
        <WifiOffIcon fontSize="small" />
        <Typography variant="body2" sx={{ fontWeight: 600 }}>
          You're offline. Changes may not save until you reconnect.
        </Typography>
      </Box>
    </Slide>
  );
};

export default OnlineStatus;
